import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box } from "@material-ui/core";
import EditText from "../../components/EditText";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  street: Yup.string().required("Street is required"),
  city: Yup.string().required("City is required"),
  cap: Yup.string().required("Cap is required"),
  district: Yup.string().required("District is required"),
  country: Yup.string().required("Country is required"),
});

const PlantForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <EditText {...props} label={t("create_plant.name")} name="name" />
          <EditText
            {...props}
            label={t("create_plant.country")}
            name="country"
          />
          <EditText
            {...props}
            label={t("create_plant.district")}
            name="district"
          />
          <EditText {...props} label={t("create_plant.city")} name="city" />
          <EditText {...props} label={t("create_plant.cap")} name="cap" />
          <EditText {...props} label={t("create_plant.street")} name="street" />
          <Box my={2}>
            <Submit {...props} title={t("create_plant.save")} />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default PlantForm;
